"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavLink = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _theming = require("@storybook/theming");

var _Link = require("../Link");

var _styles = require("../shared/styles");

var _HeaderContext = require("./HeaderContext");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledNavLink = /*#__PURE__*/(0, _theming.styled)(_Link.Link, process.env.NODE_ENV === "production" ? {
  target: "e1q6bakl0"
} : {
  target: "e1q6bakl0",
  label: "StyledNavLink"
})("font-size:", _styles.typography.size.s2, "px;font-weight:", _styles.typography.weight.bold, ";");
var NavLink = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _useContext = (0, _react.useContext)(_HeaderContext.HeaderContext),
      inverse = _useContext.inverse;

  return /*#__PURE__*/_react["default"].createElement(StyledNavLink, (0, _extends2["default"])({
    ref: ref,
    inverse: inverse,
    tertiary: !inverse
  }, props));
});
exports.NavLink = NavLink;
NavLink.displayName = 'NavLink';